import {createSlice} from '@reduxjs/toolkit'

export const stockSummaryReportSlice=createSlice({
    name:"stockSummarySlice",
    initialState:{
        value:undefined
    },
    reducers:{
        get_stock_summary:(state,action)=>{
            state.value=action.payload.stockSummaryData
        }
    }
})
export const {get_stock_summary} = stockSummaryReportSlice.actions;
export default stockSummaryReportSlice.reducer